import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiTablePagination(theme: Theme): MuiThemeComponentOverride<"MuiTablePagination"> {
  return {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          padding: "0 32px",
        },
        root: {
          border: "unset",
        },
        spacer: {
          flex: "unset",
        },
        toolbar: {
          justifyContent: "center",
          padding: "0",

          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          ">": {
            ".MuiIconButton-root": {
              color: theme.palette.brand.orange[500].main,

              // eslint-disable-next-line sort-keys-fix/sort-keys-fix
              "&:disabled": {
                color: theme.palette.brand.orange[100].main,
              },
            },
          },
        },
      },
    },
  };
}
